/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-24 16:27:51
 * @LastEditors: K
 * @LastEditTime: 2022-09-16 14:32:36
 */
import { Button, Col, Collapse, Input, Modal, } from 'antd';
import React, { ReactElement, useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import styles from './blindPersonmedical.module.css'
import { ThemeContext } from '../../../theme/ThemeContext';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { unwrapResult } from '@reduxjs/toolkit';
import { getUrl } from '../tcmCases/tcmCasesSlice';

export const LookPicModal = (props?: {
  lookPicList?: any[],
  isVisible?: boolean,
  patientId?: string,
  onOk?: () => void,
  onCancel?: () => void,
}): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [lookPic, setLookPic] = useState('')

  const [dataIndex, setDataIndex] = useState<any>(1)

  useEffect(() => {
    if (!props?.isVisible) {
      setDataIndex(1) 
      setLookPic('')
    } else {
      getUrlData(props?.lookPicList?.[0]?.url)
    }
  }, [props?.isVisible])

  const getUrlData = (url: string) => {
    dispatch(getUrl({ fileName: url }))
      .then(unwrapResult)
      .then((v: any) => {
        const proxy =
          window.location.origin.indexOf(
            'his.develop.hydhis.com'
          ) >= 0
            ? '/proxyToOssDevPrivate'
            : window.location.origin.indexOf(
              'his.test.hydhis.com'
            ) >= 0
              ? '/proxyToOssTestPrivate'
              : window.location.origin.indexOf(
                'hydhis.cn'
              ) >= 0
                ? '/proxyToOssProdPrivate'
                : '/proxyToOssProdPrivate'
        const url =
          (window.location.origin?.includes('localhost')
            ? 'http://hydhis.cn'
            : window.location.origin) +
          proxy +
          v
        setLookPic(url)
      })
  }
  return (
    <>
      <Modal
        width={1200}
        title='查看'
        className={styles.modalContent}
        visible={props?.isVisible}
        onOk={() => {
          props?.onOk?.()
        }}
        onCancel={() => {
          props?.onCancel?.()
        }}
      >
        <div
          style={{ display: 'flex', width: '100%', flexDirection: 'column' }}
        >
          <div style={{ display: 'flex', width: '100%', height: '520px' }}>
            <div
              style={{
                width: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <LeftOutlined
                disabled={dataIndex == 1 ? true : false}
                onClick={() => {
                  if (dataIndex == 1) {
                    setDataIndex(1)
                    getUrlData(props?.lookPicList?.[0]?.url)
                  } else {
                    setDataIndex(dataIndex - 1)
                    getUrlData(props?.lookPicList?.[dataIndex - 2]?.url)
                  }
                }}
              />
            </div>
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={lookPic}
                style={{
                  height: '530px',
                  width: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              ></img>
            </div>
            <div
              style={{
                width: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <RightOutlined
                disabled={dataIndex == props?.lookPicList?.length ? true : false}
                onClick={() => {
                  if (dataIndex == props?.lookPicList?.length) {
                    setDataIndex(props?.lookPicList?.length)
                    getUrlData(props?.lookPicList?.[props?.lookPicList?.length - 1]?.url)
                  } else {
                    setDataIndex(dataIndex + 1)
                    getUrlData(props?.lookPicList?.[dataIndex]?.url)
                  }
                }}
              />
            </div>
          </div>
          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {dataIndex}/{Number(props?.lookPicList?.length) > 0 ? props?.lookPicList?.length : 0}
          </div>
        </div>
      </Modal>
    </>
  );
}

